export const scrollToAnchor = (anchorId) => {
    console.log("anchor click")
    const anchorElement = document.getElementById(anchorId);

    if (anchorElement) {
        anchorElement.scrollIntoView({ behavior: 'smooth' });
    }
};
